const EXPLORE_LINKS = [
  { label: "实时热榜", href: "#ranking" },
  { label: "热门话题", href: "#topics" },
  { label: "话题分类", href: "#categories" },
  { label: "深度围观", href: "#dive" },
];

const ABOUT_LINKS = [
  { label: "网站口碑", href: "#voice" },
  { label: "常见问题", href: "#faq" },
  { label: "联系我们", href: "#contact" },
  { label: "回到顶部", href: "#top" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                网曝吃瓜
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              聚合全网热门吃瓜话题与热搜榜单，实时围观当下最热的讨论现场。我们只做信息的整理与呈现，帮你更快看懂热度中心，也提醒每一位围观者保持理性与克制。
            </p>
            <p className="mt-5 flex items-center gap-2 text-xs text-background-300">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-live-pulse rounded-full bg-accent-400" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
              </span>
              当前正在实时更新话题热度
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wider text-background-50">
              站内导航
            </h3>
            <ul className="mt-4 space-y-3">
              {EXPLORE_LINKS.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wider text-background-50">
              关于与帮助
            </h3>
            <ul className="mt-4 space-y-3">
              {ABOUT_LINKS.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="mailto:editor@wnchigua.com"
              className="mt-4 inline-flex items-center gap-2 text-sm text-accent-300 transition-colors hover:text-accent-200"
            >
              <i className="ri-mail-line" aria-hidden="true" />
              editor@wnchigua.com
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 网曝吃瓜 · 热点围观现场</p>
          <p>内容均为公开讨论整理，请理性围观，尊重事实与当事人。</p>
        </div>
      </div>
    </footer>
  );
}